import { handleActions } from 'redux-actions';
import { SubmissionError } from 'redux-form';

import reduce from 'lodash/reduce';
import startsWith from 'lodash/startsWith';
import forEach from 'lodash/forEach';

import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

import { enum as languages } from '../../../../../../../enums/languages';

export const namespace = 'blogArticleTagEditor';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const SET_INITIAL_VALUES = `${namespace}/set-initial-values`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const CHANGE_LANGUAGE = `${namespace}/change-language`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;

const requiredLanguages = [languages.en, languages.ru];

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false,
	language: languages.en
};

const initialFormValues = {
	name: reduce(languages, (acc, lang) => ({ ...acc, [lang]: '' }), {})
};

function mapResponseDataToStateData(data) {
	return {
		name: reduce(languages, (acc, lang) => ({ ...acc, [lang]: data.name[lang] || '' }), {})
	};
}

function getCreateRequest(payload) {
	return http({
		url: endpoints.BLOG.ARTICLE_TAGS,
		method: 'post',
		actions: [SET_INITIAL_VALUES, FETCH_DATA_ERROR],
		data: payload
	});
}

function getUpdateRequest(id, payload) {
	return http({
		url: `${endpoints.BLOG.ARTICLE_TAGS}/${id}`,
		method: 'put',
		actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR],
		data: payload
	});
}

// actions
export const actions = {
	own: {
		fetchData: (props) => (dispatch) => {
			const id = props.params.id;

			if (!id) {
				return dispatch({ type: SET_INITIAL_VALUES });
			}

			const request = http({
				url: `${endpoints.BLOG.ARTICLE_TAGS}/${id}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			});

			return request(dispatch);
		},
		onSubmit: (values, _, props) => (dispatch) => {
			const id = props.params.id;

			validate(values);

			dispatch(actions.own.toggleProgressBar());

			const request = id
				? getUpdateRequest(id, values)
				: getCreateRequest(values);

			return request(dispatch);
		},
		onChangeLang: (lang) => (dispatch, getState) => {
			dispatch({ type: CHANGE_LANGUAGE, lang });
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR })
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: mapResponseDataToStateData(action.payload.data),
			isLoading: false,
			isError: false
		}),
		[SET_INITIAL_VALUES]: (state, action) => ({
			...state,
			data: initialFormValues,
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[CHANGE_LANGUAGE]: (state, action) => ({
			...state,
			language: action.lang
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	},
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field],
	getTabLangs: (state) => {
		const languages = state.root.lists.languages;
		const currentLang = state[namespace].language;

		return languages.map((lang) => ({
			id: lang.id,
			text: lang.text,
			isSelected: true,
			isActive: lang.id === currentLang,
			isDefault: lang.id === currentLang
		}));
	}
};

function validate(values) {
	forEach(requiredLanguages, (lang) => {
		const name = values.name[lang];

		if (!name) {
			throw new SubmissionError({
				name: {
					[lang]: 'required'
				},
				_error: `${lang.toUpperCase()} required`
			});
		}

		if (startsWith(name, '#')) {
			throw new SubmissionError({
				name: {
					[lang]: 'must not start with #'
				},
				_error: `${lang.toUpperCase()}: must not start with #`
			});
		}
	});
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-tag/editor/index.js